<script lang="ts">
    import type {ThesaurusRecordDescriptor} from '../types';
    import KpThesaurusItem from '../components/KpThesaurusItem.svelte';

    export let thesaurusRoot: ThesaurusRecordDescriptor;
</script>

<div class="thesaurus-items-part">
    <KpThesaurusItem thesaurusItem="{thesaurusRoot}"/>
</div>

<style lang="less">
    .thesaurus-items-part {
        width: 100%;
    }
</style>